import dayjs from 'dayjs'
import { dateFormat, BACKEND_DATE_FORMAT } from 'consts'

export const formatDate = inputDate => {
  if (!inputDate) return null
  const parsedDate = dayjs(inputDate, dateFormat)
  // Format the parsed date to "YYYY-MM-DD" format
  const formattedDate = parsedDate?.format(BACKEND_DATE_FORMAT)
  return formattedDate
}
const serializeSex = sex => sex?.charAt(0)?.toUpperCase()

const serializeAddress = address => {
  if (!address) return null
  const countyNameOnly = address.county?.split(' ')[0] || null
  return {
    state_name_short: address.state,
    zip_code: address.zipCode,
    county_name: countyNameOnly,
    city: address.city,
    street_address_1: address.address1,
    street_address_2: address.address2
  }
}

const getHomeAdress = member => {
  // empty initial adress cannot be send to backend
  if (member.relation !== 'owner' && member.isHomeAddressAsOwner) {
    return null
  } else {
    return member.homeAddress
  }
}

export const serializeMembers = members => {
  return members.map(member => {
    const homeAddress = serializeAddress(getHomeAdress(member))
    const billingAddress = member.isMailingAddressAsHomeAddress
      ? null
      : serializeAddress(member.mailingAddress)
    return {
      id: member.id,
      first_name: member.firstName,
      last_name: member.lastName,
      ssn: member.ssn,
      date_of_birth: formatDate(member.dob),
      sex: serializeSex(member.sex),
      tobacco_user: member.isTobbacoUser,
      coverage_eligible: member.isElligible,
      phone: member.phone,
      email: member.email,
      relationship_status: member.relation,
      mailing_address: homeAddress, // in case its same as owner should be null
      billing_address: billingAddress,
      language: member.prefferedLanguage
    }
  })
}
